import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TopicService } from 'app/services/topic.service';
import { CompetitionService } from 'app/services/competition.service';
import { Topic } from 'app/models/topic';

@Component({
  selector: 'app-topics-dashboard',
  templateUrl: './topics-dashboard.component.html',
  styleUrls: ['./topics-dashboard.component.scss']
})
export class TopicsDashboardComponent implements OnInit, OnDestroy {

  topics: Array<Topic>;
  lastEvaluatedKey: any;
  private currentCompetitionId: string;
  private routerSub: Subscription;

  constructor(
    private topicService: TopicService,
    private competitionService: CompetitionService,
    private router: Router
  ) {}

  ngOnInit() {
    this.currentCompetitionId = this.competitionService.getCompetitionId();
    this.getAll();
    
    // Subscribe to navigation events to reload topics when user navigates to a different competition
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const newCompetitionId = this.competitionService.getCompetitionId();
      // Only reload if competition actually changed
      if (newCompetitionId && newCompetitionId !== this.currentCompetitionId) {
        this.currentCompetitionId = newCompetitionId;
        this.topics = null;
        this.lastEvaluatedKey = null;
        this.getAll();
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey);
  }

  getAll(lastEvaluatedKey?: string): void {
    this.topicService
      .getAll(lastEvaluatedKey)
      .subscribe(data => {
        this.topics = this.topics && lastEvaluatedKey ?
                      this.topics.concat(data.Items) : data.Items;
        this.lastEvaluatedKey = data.LastEvaluatedKey;
      });
  }

}
